  document.addEventListener('DOMContentLoaded', async function() {
    try {
      // 1. Fetch real-time exchange rate (GBP base)
      const response = await fetch('https://open.er-api.com/v6/latest/GBP');
      const data = await response.json();
      const usdRate = data.rates.USD;

      // 2. Find all tooltip containers on the page
      const tooltips = document.querySelectorAll('.usd-tooltip-container');
      
      tooltips.forEach(container => {
        // 3. Get the raw GBP price from the data attribute
        const gbpPrice = parseFloat(container.getAttribute('data-gbp-price'));
        const tooltipText = container.querySelector('.usd-tooltip-text');
        
        if (!isNaN(gbpPrice) && usdRate && tooltipText) {
          // 4. Calculate USD and update the text
          const usdPrice = (gbpPrice * usdRate).toFixed(2);
          tooltipText.innerText = `USD: ${usdPrice}$`;
        } else {
          tooltipText.innerText = 'Unavailable';
        }
      });
    } catch (error) {
      console.error('Failed to load USD exchange rate', error);
      document.querySelectorAll('.usd-tooltip-text').forEach(t => t.innerText = 'Error loading rate');
    }
  });